import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { tableConfig } from '../../../../settings/index';
import Api from '../../../../helpers/api';
import { sendRequest } from '../../../../helpers/saga';
import { logger } from '../../../../helpers/logger';
import notifications from '../../../../redux/notifications/actions';
import { IApiResponse, IListBackendResponse, ILoadAction } from './saga.types';

const api = new Api('legal_entities');

function* loadDataRequest(action: ILoadAction): Generator<unknown, void, IApiResponse<IListBackendResponse>> {
  try {
    const payload = action.payload ?? {};
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '', search } = payload;

    const result = yield call(
      sendRequest,
      api.load,
      { search: { page, pageSize, column, order, filter, search } },
      notifications.REQUEST_ERROR,
    );

    if (result?.data?.success?.data) {
      const { records, totalCount, filteredCount, sortableColumns } = result.data.success.data;

      yield put(
        actions.loadDataSuccess({
          records,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns,
        }),
      );
    } else {
      yield put(actions.loadDataError());
    }
  } catch (error) {
    logger.error(error);
    yield put(actions.loadDataError());
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_REQUEST, loadDataRequest)]);
}
